import Page from '../page';

import { inview, toggleActive } from '../../lib/inview';
import imagesLoaded from 'imagesloaded';

//import LocomotiveScroll from 'locomotive-scroll';
import Rellax from 'Rellax';


export default class WorksDetailManager extends Page {
	constructor() {
		super();
	}
	init() {
		//console.log("about");
		//gradient(this);
		//dot(this);



		this.scroll();
		this.resize();
		window.dispatchEvent(new Event('resize'));

		let mainImg = document.getElementById('mainImg');
		let infoBox = document.getElementById('infoBox');

		//console.log(mainImg);

		imagesLoaded(mainImg, function (instance) {
			//console.log('all images are loaded');

			setTimeout(() => {
				infoBox.classList.add('show');
			}, 300)

			setTimeout(() => {
				mainImg.classList.add('show');
			}, 600)


		});


		// const scroll = new LocomotiveScroll({
		// 	el: document.querySelector('[data-scroll-container]'),
		// 	smooth: true
		// });

		var rellax = new Rellax('.rellax', {
			center: true,
		});



		toggleActive(document.getElementsByClassName('maskDown'), '70%');
		toggleActive(document.getElementsByClassName('articleNext'), '70%');

		inview(document.getElementById('articleNext'), (direction) => {
			infoBox.classList.toggle('hide', direction == 'down');
		}, '70%');

	}
	scroll() {
		document.addEventListener('scroll', () => {
			//console.log(this.winScrollTop);

			if (this.winScrollTop >= 340) {
				infoBox.classList.add('active');
			} else {
				infoBox.classList.remove('active');
			}


		});
	}
	resize() {
		window.addEventListener('resize', function (e) {

		})
	}
}